/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Explore
 *| (C) Copyright IBM Corp. 2019
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */

import { getSnapshot } from 'mobx-state-tree';
/**
 * a set of APIs for driver analysis card operations
 * @module DriverAnalysisCardAPI
 */
export default class DriverAnalysisCardAPI {
	constructor(cometCardModel) {

		/**
		 * To be invoked by the product only.
		 */
		this.destroy = function() {
			cometCardModel = null;
		};

		/**
		 * @return {object} Snapshot of the state
		 */
		this.getState = function() {
			return getSnapshot(cometCardModel);
		};

		/**
		 * get driver selections of a driver analysis vis
		 * @return {array} current driver selections of a driver analysis vis
		 */
		this.getSelections = function() {
			return cometCardModel.getSelections();
		};

		/**
		 * get recommendations
		 * @return {array} recommendations on a driver;
		 */
		this.getRecommendations = function () {
			return cometCardModel.getRecommendations();
		};

		/**
		 * get associated predict data that used for footer view rendering
		 * @return {object} the predict data used to render footer view;
		 */
		this.getAssociatedPredictData = function() {
			return cometCardModel.getFooterRenderData();
		};

		/**
		 * Given an recomendation, return the coverted widget spec
		 * @param {object} recommendation
		 * @example
		 * the recommendation example
		 *	{
		 *		widgets: [
		 *			{
		 *				spec: {
		 *					visId: 'com.ibm.vis.*',
		 *					data: {
		 *						dataViews: [{
		 *
		 *						}]
		 *					},
		 *					...
		 *				}
		 *			}
		 *		]
		 *	}
		 *
		 * @return {object} widget spec (In more details, the returned widget spec will contain the key drivers from the source widget if the recommended widget is decision tree chart)
		 */
		this.covertRecommendationToWidgetSpec = function(recommendation) {
			return cometCardModel.covertRecommendationToWidgetSpec(recommendation);
		};
	}
}



// WEBPACK FOOTER //
// ./src/js/api/DriverAnalysisCardAPI.js